import { render, staticRenderFns } from "./YBquery.vue?vue&type=template&id=1a3547a7&"
import script from "./YBquery.vue?vue&type=script&lang=js&"
export * from "./YBquery.vue?vue&type=script&lang=js&"
import style0 from "./YBquery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports